module.exports = __webpack_public_path__ + "static/media/paypal.59703ba3.svg";